export const LOAD_INSTRUCTOR_COURSE_GROUPS_SUCCESS = 'LOAD_INSTRUCTOR_COURSE_GROUPS_SUCCESS';
export const LOAD_INSTRUCTOR_COURSE_GROUPS_FAILURE = 'LOAD_INSTRUCTOR_COURSE_GROUPS_FAILURE';
export const ADD_INSTRUCTOR_COURSE_GROUPS_SUCCESS = 'ADD_INSTRUCTOR_COURSE_GROUPS_SUCCESS';
export const EDIT_INSTRUCTOR_COURSE_GROUPS_SUCCESS = 'EDIT_INSTRUCTOR_COURSE_GROUPS_SUCCESS';
export const DELETE_INSTRUCTOR_COURSE_GROUPS_SUCCESS = 'DELETE_INSTRUCTOR_COURSE_GROUPS_SUCCESS';
export const REORDER_INSTRUCTOR_COURSE_GROUPS_SUCCESS = 'REORDER_INSTRUCTOR_COURSE_GROUPS_SUCCESS';
export const REORDER_GLOBAL_INSTRUCTOR_COURSE_GROUPS_SUCCESS = 'REORDER_GLOBAL_INSTRUCTOR_COURSE_GROUPS_SUCCESS';
export const LOAD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS = 'LOAD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS';
export const LOAD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE = 'LOAD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE';
export const DELETE_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS = 'DELETE_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS';

export const ADD_INSTRUCTOR_GROUP_CONCEPTS_REQUEST = 'ADD_INSTRUCTOR_GROUP_CONCEPTS_REQUEST';
export const ADD_INSTRUCTOR_GROUP_CONCEPTS_PROGRESS = 'ADD_INSTRUCTOR_GROUP_CONCEPTS_PROGRESS';
export const ADD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS = 'ADD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS';
export const ADD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE = 'ADD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE';
export const ADD_INSTRUCTOR_GROUP_CONCEPTS_RESET = 'ADD_INSTRUCTOR_GROUP_CONCEPTS_RESET';

export const PUBLISH_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS = 'PUBLISH_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS';
export const PUBLISH_INSTRUCTOR_CHAPTER_SUCCESS = 'PUBLISH_INSTRUCTOR_CHAPTER_SUCCESS';
export const REORDER_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS = 'REORDER_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS';

export const INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS = 'INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS';

export const EDIT_INSTRUCTOR_CHAPTER_CONTENTS_REQUEST = 'EDIT_INSTRUCTOR_CHAPTER_CONTENTS_REQUEST'